
import { defineComponent, reactive, ref, shallowReactive, shallowRef } from 'vue';
export default defineComponent({
    name: 'App',
    setup() {
        const m1 = reactive({
            name: 'reactive',
            age: 20,
            a: {
                b: 0
            }
        });
        const m2 = shallowReactive({
            name: 'shallowReactive',
            age: 20,
            a: {
                b: 0
            }
        });
        const m3 = ref({
            name: 'ref',
            age: 20,
            a: {
                b: 0
            }
        });
        const m4 = shallowRef({
            name: 'shallowRef',
            age: 20,
            a: {
                b: 0
            }
        });
        const update = () => {
            // m1.a.b++;
            m2.a.b++;
            // m3.value.a.b++;
            // m4.value.a.b++;
            m4.value.name += "==";
        };
        return {
            m1,
            m2,
            m3,
            m4,
            update,
        }
    }
});
